import FocusLock from 'react-focus-lock';
import type { ReactFocusLockProps } from 'react-focus-lock/interfaces';

export function FocusTrap({ children, ...props }: ReactFocusLockProps) {
  return <FocusLock {...props}>{children}</FocusLock>;
}
